import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'



export const downloadCreditReport = createAsyncThunk(
  'downloadCreditReport/v1',
  async ({ jwtBearer, updatedOn, rpm }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}pipeline/selected/credit/data`
      const params = new URLSearchParams()
      if (rpm) {
        params.append('rpm', rpm)
      }
      if (params.toString()) {
        url += `?${params.toString()}`
      }

      const response = await fetch(
        url,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      )

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue('Failed to download report')
      }

      const blob = await response.blob()
      const urlBlob = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = urlBlob
      link.download = `Pipeline_Report_${updatedOn}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      URL.revokeObjectURL(urlBlob)

      return true // success flag
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const downloadCreditReportV2 = createAsyncThunk(
  'downloadCreditReport/v2',
  async ({ jwtBearer, updatedOn, rpm }, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}pipeline/selected/credit/data/v2`
      const params = new URLSearchParams()
      if (rpm) {
        params.append('rpm', rpm)
      }
      if (params.toString()) {
        url += `?${params.toString()}`
      }

      const response = await fetch(
        url,
        {
          headers: {
            Authorization: `Bearer ${jwtBearer}`
          }
        }
      )

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue('Failed to download report')
      }

      const blob = await response.blob()
      const urlBlob = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = urlBlob
      link.download = `Pipeline_Report_${updatedOn}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      URL.revokeObjectURL(urlBlob)

      return true
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchRpmList = createAsyncThunk(
  'downloadCreditReport/fetchRpmList',
  async ({ jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}pipeline/rpm/list`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      })

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload()
        }
        return rejectWithValue('Failed to fetch RPM list')
      }

      const data = await response.json()
      return data.message
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)



const downloadCreditReportSlice = createSlice({
  name: 'downloadCreditReport',
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    rpmList: []
  },
  reducers: {
    resetDownloadState: state => {
      state.isLoading = false
      state.isError = false
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(downloadCreditReport.pending, state => {
        state.isLoading = true
        state.isError = false
        state.error = null
      })
      .addCase(downloadCreditReport.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(downloadCreditReport.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })

      .addCase(downloadCreditReportV2.pending, state => {
        state.isLoading = true
        state.isError = false
        state.error = null
      })
      .addCase(downloadCreditReportV2.fulfilled, state => {
        state.isLoading = false
      })
      .addCase(downloadCreditReportV2.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })

      .addCase(fetchRpmList.pending, state => {
        state.isLoading = true
      })
      .addCase(fetchRpmList.fulfilled, (state, action) => {
        state.isLoading = false
        state.rpmList = action.payload
      })
      .addCase(fetchRpmList.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.error = action.payload
      })
  }
})

export const { resetDownloadState } = downloadCreditReportSlice.actions
export default downloadCreditReportSlice.reducer
